import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { selectAuthStatus, selectUser } from '../../selectors/users'
import { LoadingPage } from './loading_page'

// Gate for the admin surface. Holds off while /me is in flight (same reasoning as
// RequireUser), then requires a resolved superadmin. Anyone else — anonymous or a
// signed-in non-admin — is bounced to /not-found rather than shown a forbidden
// screen, so the admin routes don't advertise their existence.
export const RequireAdmin = ({ children }) => {
  const authStatus = useSelector(selectAuthStatus)
  const user = useSelector(selectUser)

  if (authStatus === 'loading') return <LoadingPage />
  if (!user?.isAdmin) return <Navigate to="/not-found" replace />
  return children
}
